import { topicItems } from '@/mocks/home';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500">探索你最感兴趣的漫画话题与分类标签</p>
          </div>

          <div className="max-w-[900px] mx-auto flex flex-wrap justify-center gap-3">
            {topicItems.map((topic) => (
              <div
                key={topic.id}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-full transition-colors cursor-pointer ${colorMap[topic.color]}`}
              >
                <span className="text-sm font-medium">{topic.name}</span>
                <span className="text-xs opacity-70">{topic.count}讨论</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}